export const STRONG_AUTH_STATUS = {
  PENDING: 'Pending',
  FAILED: 'Failed',
  SUCCEEDED: 'Succeeded'
};